export enum GeneralOperatorType {
  EQUAL = "EQUAL" as any,
  NOT_EQUAL = "NOT_EQUAL" as any,
  GREATER_THAN = "GREATER_THAN" as any,
  GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUAL" as any,
  LESS_THAN = "LESS_THAN" as any,
  LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUAL" as any,
  IN = "IN" as any,
  NOT_IN = "NOT_IN" as any,
}
